function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { CoreVideoConfigProvider as RemoteConfigProvider } from './core-video-config/core-video-config-provider';
import { isRemoteConfigEnabled } from './core-video-config/core-video-config-types';
import { PlaybackType } from '../core/player/playout-data';
import { GLOBAL_MUTED_ERROR_CODES } from './conviva-blocklist';
import { LocalConfigProvider } from './local-config-provider';
export var InternalConfigProvider = /*#__PURE__*/ function() {
    "use strict";
    function InternalConfigProvider(sdkConfig, device, compiledConfigLoader) {
        _class_call_check(this, InternalConfigProvider);
        _define_property(this, "sdkConfig", void 0);
        _define_property(this, "device", void 0);
        _define_property(this, "compiledConfigLoader", void 0);
        _define_property(this, "internalConfigPerPlaybackType", void 0);
        _define_property(this, "externalConfigProvider", void 0);
        this.sdkConfig = sdkConfig;
        this.device = device;
        this.compiledConfigLoader = compiledConfigLoader;
    }
    _create_class(InternalConfigProvider, [
        {
            key: "initialise",
            value: function initialise() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (isRemoteConfigEnabled(_this.sdkConfig)) {
                                    _this.externalConfigProvider = new RemoteConfigProvider(_this.sdkConfig, _this.device, _this.compiledConfigLoader);
                                } else {
                                    _this.externalConfigProvider = new LocalConfigProvider(_this.sdkConfig, _this.device, _this.compiledConfigLoader);
                                }
                                return [
                                    4,
                                    _this.externalConfigProvider.initialise()
                                ];
                            case 1:
                                _state.sent();
                                _this.internalConfigPerPlaybackType = _this.buildConfig();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getConfig",
            value: function getConfig() {
                var _this_externalConfigProvider;
                if (!this.internalConfigPerPlaybackType || !this.externalConfigProvider) {
                    throw new Error('Tried to retrieve config before internal config provider was initialised');
                }
                var failOverReason = ((_this_externalConfigProvider = this.externalConfigProvider) === null || _this_externalConfigProvider === void 0 ? void 0 : _this_externalConfigProvider.getFailoverReason()) || 'NA';
                if (!this.externalConfigProvider.checkHasConfigChanged(this.internalConfigPerPlaybackType.default.configMetadata.configIdentifier)) {
                    return [
                        this.internalConfigPerPlaybackType,
                        failOverReason
                    ];
                }
                this.internalConfigPerPlaybackType = this.buildConfig();
                return [
                    this.internalConfigPerPlaybackType,
                    failOverReason
                ];
            }
        },
        {
            key: "applyBufferingLimitModifications",
            value: function applyBufferingLimitModifications(config) {
                var defaultRebufferingLimitConfig = {
                    enableRebufferingLimit: true,
                    enableSeekingLimit: false,
                    maxMainContentBufferingSecs: 60,
                    maxAdvertBufferingSecs: 10
                };
                config.bufferingLimit = defaultRebufferingLimitConfig;
            }
        },
        {
            key: "applyGlobalReportingConfig",
            value: function applyGlobalReportingConfig(dynamicConfig) {
                var _dynamicConfig_addons_reporting;
                if (!((_dynamicConfig_addons_reporting = dynamicConfig.addons.reporting) === null || _dynamicConfig_addons_reporting === void 0 ? void 0 : _dynamicConfig_addons_reporting.conviva)) {
                    return;
                }
                var mutedErrorCodes = _to_consumable_array(dynamicConfig.addons.reporting.conviva.config.mutedErrorCodes || []).concat(_to_consumable_array(GLOBAL_MUTED_ERROR_CODES));
                dynamicConfig.addons.reporting.conviva.config.mutedErrorCodes = mutedErrorCodes;
            }
        },
        {
            key: "applyCommonModifications",
            value: function applyCommonModifications(internalConfig) {
                var _this = this;
                var staticConfig = internalConfig.staticConfig, dynamicConfig = _object_without_properties(internalConfig, [
                    "staticConfig"
                ]);
                this.applyBufferingLimitModifications(staticConfig);
                Object.values(dynamicConfig).forEach(function(config) {
                    _this.applyGlobalReportingConfig(config);
                });
            }
        },
        {
            key: "buildStaticConfig",
            value: function buildStaticConfig() {
                return {
                    proposition: this.sdkConfig.proposition,
                    devices: this.sdkConfig.devices,
                    deviceOverride: this.sdkConfig.deviceOverride,
                    playerOverride: this.sdkConfig.playerOverride,
                    debug: this.sdkConfig.debug,
                    drm: this.sdkConfig.drm,
                    vpi: this.sdkConfig.vpi,
                    bufferingLimit: undefined
                };
            }
        },
        {
            key: "buildConfig",
            value: function buildConfig() {
                var _this = this;
                var configProvider = this.externalConfigProvider;
                if (!configProvider) {
                    throw new Error('Tried to retrieve config before internal config provider was initialised');
                }
                var internalConfigPerPlaybackType = {
                    staticConfig: this.buildStaticConfig(),
                    default: configProvider.buildInternalConfig('default', this.device)
                };
                Object.keys(PlaybackType).forEach(function(playbackTypeKey) {
                    var playbackType = playbackTypeKey;
                    var internalConfig = configProvider.buildInternalConfig(playbackType, _this.device);
                    if (internalConfig) {
                        internalConfigPerPlaybackType[playbackType] = internalConfig;
                    }
                });
                this.applyCommonModifications(internalConfigPerPlaybackType);
                return internalConfigPerPlaybackType;
            }
        }
    ], [
        {
            key: "getForPlaybackType",
            value: function getForPlaybackType(configPerPlaybackType, playbackType) {
                var dynamicConfig = configPerPlaybackType[playbackType] || configPerPlaybackType.default;
                return _object_spread({}, configPerPlaybackType.staticConfig, dynamicConfig);
            }
        }
    ]);
    return InternalConfigProvider;
}();

//# sourceMappingURL=internal-config-provider.js.map